// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"781de477","703":"d909f06e","787":"ff4214ba"}[chunkId] + ".chunk.js";
};